import request from "./../utils/request";

function getWhiteList() {
    return request({
        url: `/whitelist`,
        method: "get",
        params: {},
    }).then((res) => res.data);
}

function addWhiteList(data) {
    return request({
        url: `/whitelist`,
        method: "post",
        data,
    }).then((res) => res.data);
}

function removeWhiteList(id) {
    return request({
        url: `/whitelist/${id}`,
        method: "delete",
        params: {},
    }).then((res) => res.data);
}

export const WHITE_LIST_API = {
    getWhiteList,
    addWhiteList,
    removeWhiteList,
};
